export { default as default } from './TextItemDestacat';
